module.exports = __webpack_public_path__ + "img/check-mark.cffc43ee.svg";